import { render, staticRenderFns } from "./WhatsappOtpBlock.vue?vue&type=template&id=dc0349ca&"
import script from "./WhatsappOtpBlock.vue?vue&type=script&lang=js&"
export * from "./WhatsappOtpBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports